export default [
  /**
   * 选择收货地址
   */
  {
    path: '/ship/choose',
    component: () => import('../../src/pages/ship/choose-address.vue')
  },
  /**
   * 全部收货地址
   */
  {
    path: '/ship/base',
    component: () => import('../../src/pages/ship/address-base.vue')
  },
  /**
   *增加收货地址
   */
  {
    path: '/ship/add',
    meta: {
      title: '添加地址'
    },
    component: () => import('../../src/pages/ship/add-address.vue')
  },
  /**
   * 百度地图选择地址
   */
  {
    path: '/ship/add/map',
    meta: {
      title: '添加地址'
    },
    component: () => import('../../src/pages/ship/add-from-map.vue')
  },
  /**
   * 地址搜索页
   */
  {
    path: '/ship/search',
    meta: {
      title: '添加地址'
    },
    component: () => import('../../src/pages/ship/search.vue')
  },
  /**
   *药品配送记录
   */
  {
    path: '/shipping',
    component: () => import('../../src/pages/ship/drug-shipping.vue'),
    children: [
      {
        path: ':id',
        component: () => import('../../src/pages/ship/ship-state.vue')
      }
    ]
  },
  //到店自取药品
  {
    path: '/take/drug',
    meta: {
      title: '到店取药'
    },
    component: () => import('../../src/pages/ship/take-drug-shop.vue')
  },
]



// WEBPACK FOOTER //
// ./src/router/ship.js